export const testimonialsData = [
  {
    id: 1,
    name: 'سارا محمدی',
    role: 'کارشناس منابع انسانی',
    quote: 'با کارلند تونستم شغل دائمی با بیمه و قرارداد رسمی پیدا کنم. واقعاً تیم حرفه‌ای و متعهدی دارن که از روز اول تا آخر کنارم بودن. امنیت شغلی واقعی رو اینجا تجربه کردم.',
    rating: 5,
  },
  {
    id: 2,
    name: 'امیر رضایی',
    role: 'مدیرعامل فناوران نوین',
    quote: 'به عنوان یه کارفرما، کارلند بهترین نیروها رو بهم معرفی کرد. کیفیت کارشون واقعاً فراتر از انتظارم بود. دیگه از پیدا کردن نیروی متخصص استرس ندارم.',
    rating: 4.9,
  },
  {
    id: 3,
    name: 'نرگس کریمی',
    role: 'مهندس نرم‌افزار',
    quote: 'بعد از ماه‌ها جستجوی بی‌نتیجه، کارلند توی کمتر از دو هفته یه موقعیت عالی برام پیدا کرد. شرکتی که الان توش کار می‌کنم واقعاً رویاییه.',
    rating: 5,
  },
  {
    id: 4,
    name: 'محمد جوادی',
    role: 'تکنسین برق صنعتی',
    quote: '۹ سال سابقه کارلند واقعاً مشخصه. همه چی مرتب و قانونیه، قرارداد محضری دارم، بیمه کامل رد میشه و حقوقم سر موعده. این یعنی امنیت شغلی واقعی.',
    rating: 4.8,
  },
  {
    id: 5,
    name: 'لیلا حسینی',
    role: 'مدیر مالی',
    quote: 'مشاوره‌ای که از کارلند گرفتم واقعاً مسیر شغلیم رو تغییر داد. راهنمایی‌هاشون دقیق و کارشناسیه بود. الان یه شغل دارم که دقیقاً مطابق تخصص و علاقه‌مه.',
    rating: 5,
  },
  {
    id: 6,
    name: 'حسین مرادی',
    role: 'راننده ناوگان سنگین',
    quote: 'رفیق قدیمی کارلند رو بهم معرفی کرد. اول یه کم شک داشتم ولی الان نزدیک ۳ ساله از طریق کارلند مشغولم. هر بار که خواستم جابجا بشم بهترین گزینه رو برام پیدا کردن.',
    rating: 4.9,
  },
  {
    id: 7,
    name: 'مریم اکبری',
    role: 'طراح گرافیک',
    quote: 'حس خوبیه که بدونی یه موسسه معتبر پشتته. کارلند فقط یه کاریابی نیست، یه پشتیبان واقعیه. از روز مصاحبه تا روز اول کار کنارم بودن.',
    rating: 5,
  },
  {
    id: 8,
    name: 'پیمان شریفی',
    role: 'سرپرست انبار',
    quote: 'با ۱۵ سال سابقه کار، خیلی سخت‌گیرم. ولی کارلند با اون همه مجوز و سابقه، اعتمادمو جلب کرد. الان ۸ ماهه مشغولم و همه چی عالیه پیش میره.',
    rating: 4.8,
  },
  {
    id: 9,
    name: 'زهرا نعمتی',
    role: 'پرستار',
    quote: 'توی رشته ما پیدا کردن کار با امنیت بالا واقعاً سخته. کارلند یه فرصت عالی برام ساخت توی بهترین مرکز درمانی. هم قرارداد دارم هم بیمه تکمیلی.',
    rating: 5,
  },
  {
    id: 10,
    name: 'علی فتاحی',
    role: 'مهندس عمران',
    quote: 'پروژه‌هایی که کارلند معرفی کرد همشون معتبر و بزرگ بودن. الان سرپرست کارگاه یه پروژه ملی هستم. مدیون کارلند و تیم حرفه‌ایشونم.',
    rating: 4.9,
  },
  {
    id: 11,
    name: 'سمیرا جعفری',
    role: 'منشی اداری',
    quote: 'فرقی نداره چه مدرکی داری، کارلند برای همه یه شغل خوب پیدا می‌کنه. من با مدرک دیپلم الان توی یه شرکت بزرگ کار می‌کنم با بیمه و حقوق عالی.',
    rating: 5,
  },
  {
    id: 12,
    name: 'بهنام کاظمی',
    role: 'سرآشپز',
    quote: 'از آشپزخونه یه رستوران کوچیک رسیدم به سرآشپزی هتل پنج ستاره، همهش رو مدیون کارلندم. اعتماد به نفس شغلیم چند برابر شده.',
    rating: 4.8,
  },
  {
    id: 13,
    name: 'راحله صادقی',
    role: 'حسابدار',
    quote: 'بعد از کلی گشتن توی سایت‌های مختلف، فقط کارلند بود که یه موقعیت واقعی و مطمئن برام پیدا کرد. پشتیبانی بعد از استخدامشونم فوق‌العاده‌ست.',
    rating: 5,
  },
  {
    id: 14,
    name: 'مهدی رستمی',
    role: 'کارشناس فروش',
    quote: 'کارلند مثل یه دوسته که همیشه هواتو داره. هر مشکلی تو کار داشتم باهام تماس گرفتن و حلش کردن. این امنیت شغلی یعنی همین حس خوب.',
    rating: 4.9,
  },
  {
    id: 15,
    name: 'فاطمه عباسی',
    role: 'معلم',
    quote: 'آموزشگاه معتبری که کارلند معرفی کرد باورم نمیشد همچین جایی وجود داره. حقوقم دو برابر قبلیه و آبرومندانه کار می‌کنم. خدا خیرشون بده.',
    rating: 5,
  },
  {
    id: 16,
    name: 'سعید نوروزی',
    role: 'کارشناس IT',
    quote: 'فرآیند کاریابی رو کاملاً حرفه‌ای انجام میدن. از بررسی رزومه تا هماهنگی مصاحبه و حتی مذاکره حقوق، همه چی رو کامل پشتیبانی کردن.',
    rating: 5,
  },
  {
    id: 17,
    name: 'الهه ذبیحی',
    role: 'مدیر دفتر',
    quote: 'شرکتی که توش کار می‌کنم کارلند رو برای جذب نیرو معرفی کرد. حالا هر کی رو می‌بینم تو پیشنهاد میدم به کارلند مراجعه کنه. واقعاً متخصصن.',
    rating: 4.8,
  },
  {
    id: 18,
    name: 'کاوه ملکی',
    role: 'تکنسین تاسیسات',
    quote: 'بهترین تصمیم شغلی زندگیم مراجعه به کارلند بود. الان حقوق و مزایام نسبت به قبل ۶۰٪ بیشتر شده و قرارداد دائم دارم. استرس بیکاری دیگه ندارم.',
    rating: 4.9,
  },
  {
    id: 19,
    name: 'شیرین بختیاری',
    role: 'اپراتور تولید',
    quote: 'توی کارخونه‌ای که کارلند معرفی کرد همه چی سر جاشه. حقوق به موقع، بیمه کامل، اضافه‌کاری حساب شده. فرق کارلند با بقیه رو حس می‌کنی.',
    rating: 5,
  },
  {
    id: 20,
    name: 'فرهاد یوسفی',
    role: 'مهندس مکانیک',
    quote: 'کارلند نه تنها شغل پیدا کرد، بلکه مسیر رشد شغلیم رو هم برام مشخص کرد. مشاوره‌هاشون باعث شد بدونی کجا می‌تونی پیشرفت کنی.',
    rating: 4.9,
  },
  {
    id: 21,
    name: 'آزاده رحیمی',
    role: 'منابع انسانی',
    quote: 'از دید یه متخصص HR میگم، کارلند واقعاً اصولی کار می‌کنه. فرآیند جذب، غربالگری و معرفی نیرو رو کاملاً حرفه‌ای انجام میدن.',
    rating: 5,
  },
  {
    id: 22,
    name: 'امید قاسمی',
    role: 'راننده اسنپ',
    quote: 'حتی برای کارهای خدماتی هم موقعیت خوب دارن. الان راننده شرکتی شدم با حقوق ثابت و بیمه، دیگه استرس درآمد متغیر ندارم. عالیه.',
    rating: 4.8,
  },
  {
    id: 23,
    name: 'نیلوفر طاهری',
    role: 'مترجم',
    quote: 'پروژه‌های ترجمه‌ای که کارلند معرفی کرد همه از شرکت‌های معتبر بودن. درآمدم ۳ برابر شده و دیگه نیازی به کار آزاد ندارم.',
    rating: 5,
  },
  {
    id: 24,
    name: 'رضا کرمانی',
    role: 'مسئول ایمنی',
    quote: 'ایمنی شغلی حرف اول رو میزنه و کارلند دقیقاً همینه. شرکت‌هایی که معرفی می‌کنن همه مجوز دارن و استانداردهای ایمنی رو رعایت می‌کنن.',
    rating: 4.9,
  },
  {
    id: 25,
    name: 'سپیده رجبی',
    role: 'آرایشگر',
    quote: 'سالن آرایشی که کارلند معرفی کرد واقعاً لوکس و حرفه‌ایه. مشتری‌های خوبی دارم و درآمدم عالی شده. بدون کارلند این موقعیت رو پیدا نمی‌کردم.',
    rating: 5,
  },
  {
    id: 26,
    name: 'داریوش همتی',
    role: 'سرپرست تولید',
    quote: '۸ ساله از طریق کارلند توی سه تا شرکت مختلف کار کردم. هر بار که خواستم تغییر کنم بهترین گزینه رو جلوم گذاشتن. وفادارترین مشتریشونم.',
    rating: 4.9,
  },
  {
    id: 27,
    name: 'مژگان شعبانی',
    role: 'کارشناس آزمایشگاه',
    quote: 'توی رشته ما پیدا کردن کار آزمایشگاهی با امنیت بالا واقعاً دشواره. کارلند توی کمتر از یک ماه موقعیت ایده‌آل رو برام پیدا کرد.',
    rating: 5,
  },
  {
    id: 28,
    name: 'احسان پورمحمد',
    role: 'برنامه‌نویس',
    quote: 'استارتاپی که کارلند معرفی کرد الان جزء تاپ‌های اکوسیستمه. از روزی که رفتم اونجا، هم رشد کردم هم حقوقم چند برابر شده.',
    rating: 5,
  },
  {
    id: 29,
    name: 'یگانه صفری',
    role: 'کارشناس بازاریابی',
    quote: 'مشاور کارلند قبل از معرفی شغل، کلی وقت گذاشت تا مهارت‌ها و علایقم رو بشناسه. نتیجه‌ش یه شغلی شد که هر روز با عشق میرم سر کار.',
    rating: 4.8,
  },
  {
    id: 30,
    name: 'آرش محمودی',
    role: 'جوشکار صنعتی',
    quote: 'برای کارگرای فنی هم کارلند فوق‌العاده‌ست. کارگاه‌هایی که معرفی می‌کنن همه مجوز دارن و حقوقت رو کامل می‌گیری. جرأت نداشتم همچین انتظاری داشته باشم.',
    rating: 5,
  },
  {
    id: 31,
    name: 'طناز امینی',
    role: 'مدیر محتوا',
    quote: 'دورکاری با حقوق تمام‌وقت پیدا کردم. کارلند درک می‌کنه نیاز نسل جدید چیه و چطور می‌تونه بهترین تطبیق رو ایجاد کنه. خوشحالم که پیداشون کردم.',
    rating: 4.9,
  },
  {
    id: 32,
    name: 'کامران عباسپور',
    role: 'مهندس برق',
    quote: 'بعد از اخراج از شرکت قبلی کاملاً ناامید شده بودم. کارلند نه تنها روحیه‌م رو برگردوند، که یه کار بهتر از قبلی هم برام پیدا کرد. بی‌نهایت ممنونم.',
    rating: 5,
  },
  {
    id: 33,
    name: 'هانیه گلشن',
    role: 'وکیل',
    quote: 'به عنوان یه حقوقدان، قراردادهایی که کارلند تنظیم می‌کنه رو خوندم. همه چی کاملاً قانونی و به نفع کارجوئه. خیالت از هر نظر راحته.',
    rating: 5,
  },
  {
    id: 34,
    name: 'فرزاد نیکخواه',
    role: 'نقاش ساختمان',
    quote: 'حتی برای مشاغل خدماتی هم رفتارشون محترمانه‌ست. آدم حس می‌کنه واقعاً براشون مهمه. کارفرما هم که معرفی کردن آدم شریفی بود. دستشون درد نکنه.',
    rating: 4.8,
  },
  {
    id: 35,
    name: 'سودابه فرهادی',
    role: 'مدیر پروژه',
    quote: '۹ سال سابقه کارلند یعنی ۹ سال اعتمادسازی. شرکتی که منو فرستادن، الان پروژه‌های ملی انجام میده و من مدیر ارشد پروژه‌ش شدم. این یعنی سرمایه‌گذاری روی آدم.',
    rating: 5,
  },
];